import React, { PureComponent } from 'react';

class TablaHeader extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return <thead>
            <tr>
                <th className="default-td">
                    Fecha Valor
            </th>
                <th className="default-td">
                    Fecha de Imputación
            </th>
                <th className="default-td">
                    Importe $
            </th>
                <th className="default-td">
                    Importe U$S
            </th>
                <th className="default-td">
                    Referencia
            </th>
                <th className="default-td">
                    Estado
            </th>
                <th className="default-td" colSpan="4">
                    Acciones
            </th>
                <th className="default-td" colSpan="4">
            </th>
            </tr>
        </thead>
    }
}

export default TablaHeader;